import { render, staticRenderFns } from "./ProteinLoader.vue?vue&type=template&id=0b1bf610&scoped=true&"
import script from "./ProteinLoader.vue?vue&type=script&lang=js&"
export * from "./ProteinLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProteinLoader.vue?vue&type=style&index=0&id=0b1bf610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1bf610",
  null
  
)

export default component.exports